export { default } from "@material-ui/core/styles/createPalette";
export * from "@material-ui/core/styles/createPalette";
